import { formatCurrency } from './formatters';
const VALID_SOURCES = ['product', 'manufacturer', 'method'];
const SOURCE_SUFFIX = {
    product: '',
    manufacturer: ' (manufacturer)',
    method: ' (base)',
};
/**
 * Normalizes a raw shipping_breakdown payload from the API into typed entries.
 *
 * Handles two important edge cases:
 * - `raw` is undefined/null/non-array (the calculate-tax endpoint omits this key
 *   entirely when the request didn't include cart items - this is the pre-rollout
 *   and backward-compatible case) -> returns [].
 * - `amount` may arrive as a decimal string (DRF serializes DecimalField that way,
 *   e.g. "12.50") rather than a number -> coerced with parseFloat. Without this,
 *   summing entries would concatenate strings instead of adding numbers.
 */
export const normalizeShippingBreakdown = (raw) => {
    if (!Array.isArray(raw))
        return [];
    return raw.reduce((acc, entry) => {
        const amount = typeof entry?.amount === 'string' ? parseFloat(entry.amount) : entry?.amount;
        if (!Number.isFinite(amount))
            return acc;
        const source = VALID_SOURCES.includes(entry?.source)
            ? entry.source
            : 'method';
        acc.push({ label: String(entry?.label ?? 'Shipping'), source, amount: Number(amount) });
        return acc;
    }, []);
};
export const sumShippingBreakdown = (entries) => entries.reduce((sum, entry) => sum + entry.amount, 0);
export const formatShippingBreakdownLabel = (entry) => `${entry.label}${SOURCE_SUFFIX[entry.source] ?? ''}`;
/**
 * Reproduces today's shipping-total display rule: while loading show "Calculating...",
 * a falsy (zero/undefined) total reads as "Free", otherwise format as currency.
 */
export const formatShippingTotal = (total, loading = false) => {
    if (loading)
        return 'Calculating...';
    if (!total)
        return 'Free';
    return formatCurrency(total);
};
